import { NgModule } from '@angular/core';
import { GlobalAlertMessageComponent } from './components';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [GlobalAlertMessageComponent],
  imports: [CommonModule, TranslateModule, NzNotificationModule],
  exports: [GlobalAlertMessageComponent],
})
export class GlobalAlertModule {}
